/* ============================================================================
 * config.js — WYF Management runtime configuration
 * ========================================================================= */

const ENV = import.meta.env || {};

window.WYF_CONFIG = {
  /* Supabase project URL — from .env or fallback */
  SUPABASE_URL: ENV.VITE_SUPABASE_URL || "https://teyhispqjsvbcutbdtjs.supabase.co",

  /* Supabase publishable key — safe for browser with RLS */
  SUPABASE_ANON_KEY: ENV.VITE_SUPABASE_ANON_KEY || "sb_publishable_PSpLQKcSsLEilZtoV0hJbw_Xpbjdoy0",

  /* Service role key REMOVED — admin ops go through edge functions only */

  /* App display name */
  APP_NAME: "What's Your Flan — Demo",

  /* Default country code for phones (Philippines = +63) */
  DEFAULT_COUNTRY_CODE: "+63",

  /* Cloudflare Turnstile sitekey — get from dash.cloudflare.com → Turnstile */
  TURNSTILE_SITEKEY: "0x4AAAAAADRMHLzV-vHDGu7W",

  /* Password reset redirect */
  PASSWORD_RESET_REDIRECT: window.location.origin + "/?reset=1",

  /* Build version — bump when deploying */
  BUILD_VERSION: "demo",
};

export default window.WYF_CONFIG;